import {JsonObject, JsonProperty} from "typescript-json-serializer";

export enum GroupType {
    Station = "station",
    TimeSeries = "timeseries"
}

@JsonObject()
export class GroupConfiguration {
    /**
     * Group ID in WIKSI
     */
    @JsonProperty()
    declare id: string;

    /**
     * Name of group in WISKI
     */
    @JsonProperty()
    declare name: string;

    /**
     * Topic the group belongs to
     */
    @JsonProperty()
    declare topic: string;

    /**
     * Type
     */
    @JsonProperty()
    declare type: GroupType;

    /**
     * Request data coverage for time series of this group
     * Data coverage is needed when time series data is displayed in graphs.
     * It is used to determine the time range for which data is available for
     * the time series of this group.
     */
    @JsonProperty()
    declare includeTimeCoverage: boolean;

    constructor() {}
}
